if (!customElements.get('slideshow-swiper')) {
  class SlideshowSwiper extends HTMLElement {
    /**
     * Section settings
     * 
     * @type {{loop: Boolean, autoplay_speed: Number, pause_on_hover: Boolean, show_navigation: Boolean, use_transparent_header: Boolean}}
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    /**
     * 使用透明导航栏
     */
    useTransparentHeader;

    constructor() {
      super();
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
      this.querySelectorAll("button[data-anchor]").forEach(button => {
        button.addEventListener("click", this.handleAnchorClick.bind(this));
      });
    }

    connectedCallback() {
      this.mySwiper = new Swiper(`#${this.id} .swiper-container`, {
        // effect: 'fade',
        loop: this.sectionSettings.loop,
        autoplay: this.sectionSettings.autoplay_speed == 0 ? false : {
          delay: this.sectionSettings.autoplay_speed * 1000,
          pauseOnMouseEnter: this.sectionSettings.pause_on_hover,
        },
        autoHeight: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: `#${this.id} .swiper-btn-next`,
          prevEl: `#${this.id} .swiper-btn-prev`,
        },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        },
        on: {
          init: this.handleSwiperInit.bind(this),
          slideChange: this.handleSlideChange.bind(this),

        },
      });
      if (this.sectionSettings.pause_on_hover && this.sectionSettings.autoplay_speed > 0) {
        this.mySwiper.el.onmouseenter = () => {
          this.mySwiper.autoplay.stop();
        };
        this.mySwiper.el.onmouseleave = () => {
          this.mySwiper.autoplay.start();
        };
      }

      this.useTransparentHeader = this.sectionSettings.use_transparent_header;
      if (this.useTransparentHeader) {
        document.body.setAttribute("data-immersive", "dark");
      }

      this.handleSlideChange();
      // const resizeObserver = new ResizeObserver((entries) => this.updateHeight());
      // resizeObserver.observe(document.body);
    }
    handleSwiperInit(swiper) {
      this.syncActiveSlideVideoPlayback();
    }
    handleSlideChange() {
      if (!this.mySwiper) return;
      this.syncActiveSlideVideoPlayback();
      // 切换 Slide 时，更新导航栏的配色
      const slide = this.mySwiper.slides[this.mySwiper.activeIndex];
      const brightness = slide.getAttribute("data-brightness");
      if (this.useTransparentHeader) {
        if (document.body?.hasAttribute("data-immersive")) {
          document.body.setAttribute("data-immersive", brightness);
        }
      }
      // 更新模块高度
      // this.updateHeight();
    }
    handleAnchorClick(event) {
      const anchor = event.target.getAttribute("data-anchor");
      const target = document.querySelector(anchor);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    /**
     * 同步轮播视频播放状态：
     * - 仅播放 active slide 中的视频
     * - 其余 slide 中的视频一律暂停
     */
    syncActiveSlideVideoPlayback() {
      if (!this.mySwiper) return;

      const activeSlide = this.mySwiper.slides[this.mySwiper.activeIndex];
      const videos = this.querySelectorAll(".swiper-slide video");

      videos.forEach((video) => {
        const videoSlide = video.closest(".swiper-slide");
        if (videoSlide !== activeSlide) {
          video.pause();
        }
      });

      const activeVideo = activeSlide?.querySelector("video");
      if (!activeVideo) return;

      activeVideo.play().catch(() => {
        // 浏览器自动播放策略可能阻止播放，这里静默处理
      });
    }

    /**
     * 更新模块高度
     */
    updateHeight() {
      if (!this.mySwiper) return;
      const slide = this.mySwiper.slides[this.mySwiper.activeIndex];
      this.style.height = slide.clientHeight - 1 + "px";
    }
  }

  customElements.define('slideshow-swiper', SlideshowSwiper);
}